module.exports = __webpack_public_path__ + "static/media/about-us-collage.d326ce38.webp";